// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    max-width: 1000vh;
    max-height: 1000vh;
    width: auto;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    overflow-y: scroll;
  }
  
  .modal-content {
    background: white;
    width: 1200px;
    max-height: 1000vh;
    height: auto;
    border-radius: 8px;
    padding: 20px;
    position: relative;
    overflow-y: scroll;
  }
  
  .modal-close {
    position: absolute;
    top: 10px;
    right: 20px;
    background: none;
    font-size: 24px;
    border: none;
    cursor: pointer;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/common/PopupPages/PageProfile.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,eAAe;EACjB","sourcesContent":[".modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    max-width: 1000vh;\n    max-height: 1000vh;\n    width: auto;\n    height: auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    overflow-y: scroll;\n  }\n  \n  .modal-content {\n    background: white;\n    width: 1200px;\n    max-height: 1000vh;\n    height: auto;\n    border-radius: 8px;\n    padding: 20px;\n    position: relative;\n    overflow-y: scroll;\n  }\n  \n  .modal-close {\n    position: absolute;\n    top: 10px;\n    right: 20px;\n    background: none;\n    font-size: 24px;\n    border: none;\n    cursor: pointer;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
